define('TescoMobile_ClubCard/js/model/plp-clubcard-price-provider',['./abstract-clubcard-price-provider'], function (Component) {
  'use strict';

  return Component.extend({
    initialize: function () {
      this._super();
      this.form.subscribe(this.handleFormUpdate, this);
    },
    getMonthlyTotal: function () {
      var _this$form;
      return (_this$form = this.form()) === null || _this$form === void 0 || (_this$form = _this$form.closest('.product-item')) === null || _this$form === void 0 || (_this$form = _this$form.find('[itemprop="price"]')) === null || _this$form === void 0 ? void 0 : _this$form.attr('content');
    },
    handleFormUpdate: function (value) {
      if (value) {
        var _value$closest;
        if ((value === null || value === void 0 || (_value$closest = value.closest('.product-item')) === null || _value$closest === void 0 || (_value$closest = _value$closest.find('.clubcard-stripe__info')) === null || _value$closest === void 0 ? void 0 : _value$closest.length) > 0) {
          var _value$closest2;
          const price = (_value$closest2 = value.closest('.product-item')) === null || _value$closest2 === void 0 || (_value$closest2 = _value$closest2.find('.clubcard-stripe__info')) === null || _value$closest2 === void 0 || (_value$closest2 = _value$closest2.data('clubcard')) === null || _value$closest2 === void 0 ? void 0 : _value$closest2.replace('£', '');
          if (price !== null && price !== void 0 && price.length) {
            this.clubCardPrice(price);
          } else {
            this.clubCardPrice(null);
          }
        }
      } else {
        this.clubCardPrice(null);
      }
    }
  });
});

